var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tabs',{staticClass:"elevation-3",attrs:{"vertical":"","value":_vm.activeTab}},_vm._l((_vm.elements),function(element,index){return _c('v-tab',{key:index,staticClass:"black--text",attrs:{"active-class":"primary--text"},on:{"click":function($event){return _vm.goTo('#' + element.id)}}},[_vm._v(_vm._s(element.text))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }